import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';

import { AppState } from './models/app-state';

export const useAppSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
